import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import NumberInput from '../../common/controls/numberInput';
const OrganizationCoatingInput = ({
  coatingScoreDivisions: _coatingScoreDivisions = [],
  labelText,
  index,
  onChange
}) => {
  // Ensure that the coatingScoreDivision exists at that index before
  // applying, or return ''
  const value = _coatingScoreDivisions && _coatingScoreDivisions.length ? _coatingScoreDivisions[index].cost : '';
  const handleChange = newValue => {
    onChange(`coatingScoreDivisions[${index}]/cost`, newValue);
  };
  return /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(NumberInput, {
    label: labelText,
    value: value,
    entity: "CoatingScoreDivision",
    field: `cost${index}`,
    onChange: handleChange
  }));
};
OrganizationCoatingInput.propTypes = {
  coatingScoreDivisions: PropTypes.arrayOf(PropTypes.shape({
    cost: PropTypes.number
  })),
  index: PropTypes.number.isRequired,
  labelText: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};
export default OrganizationCoatingInput;